module.exports = __webpack_public_path__ + "img/2.23987f7a.jpg";